// Markdown link handling for the public Trust Center pages.
//
// Kept in its own module (not alongside the TrustLayout component) so the file
// exports only this config object — satisfies react-refresh/only-export-components.

import { Link } from 'react-router-dom';
import type { Components } from 'react-markdown';
import { hasTrustDoc, TRUST_INDEX_SLUG } from './trustDocs';

/**
 * Link handling for Trust Center markdown:
 *  - http(s) and mailto links render as normal anchors.
 *  - in-pack links (e.g. ./security-whitepaper.md) become SPA links to
 *    /trust/<slug>.
 *  - links to other repo files (docs/runbooks/…, src/lib/…) are not web-served,
 *    so they render as plain text rather than broken links.
 */
export const trustMarkdownComponents: Components = {
  a({ href, children, ...props }) {
    const h = href ?? '';

    if (h.startsWith('mailto:')) {
      return <a href={h} {...props}>{children}</a>;
    }
    if (/^https?:\/\//.test(h)) {
      return <a href={h} target="_blank" rel="noreferrer" {...props}>{children}</a>;
    }
    if (h.endsWith('.md')) {
      const slug = h.split('/').pop()!.replace(/\.md$/, '');
      if (slug !== TRUST_INDEX_SLUG && hasTrustDoc(slug)) {
        return <Link to={`/trust/${slug}`}>{children}</Link>;
      }
      // Repo file that isn't part of the published web pack — drop the link.
      return <>{children}</>;
    }
    if (h.startsWith('/')) {
      return <Link to={h}>{children}</Link>;
    }
    return <>{children}</>;
  },
};
